var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.onItemClick($event)}}},[_vm._v(_vm._s(_vm.values.content))])}
var staticRenderFns = []

export { render, staticRenderFns }